const events = []

const handlers = (type) => events[type] || []

export const addListener = (type, handler) => {
	if (!events[type]) {
		events[type] = []
	}
	events[type].push(handler)
}

export const removeListener = (type, handler) => {
	events[type] = handlers(type).filter(fn => fn !== handler)
}

export const emit = (type, data) => {
	handlers(type).forEach(handler => {
		setTimeout(handler, 0, data)
	})
}



// WEBPACK FOOTER //
// ./src/events.js